export default {
    title: 'Sign Up',
    invitation_title: 'Invitation of {caller}',
    finalize_profile: 'Finish setting your profile',
    subtitle: 'Already have an account?',
    sign_in: 'Sign In',
    messages: {
        register_success: 'Registration completed! Please confirm the email to continue.',
        invite_success: 'Invitation completed! Please login to continue.',
    },
}
